import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { createReducer } from "utils/ReducerUtils";
import { groupsReducers } from "./groupsReducer";
import { rolesReducers } from "./rolesReducer";
import { userReducers } from "./usersReducer";
import type { AclReduxState } from "./types";

export type { AclReduxState } from "./types";

export const initialState: AclReduxState = {
  isLoading: false,
  isLoadingMore: false,
  isSavingName: false,
  isEditing: false,
  users: {
    content: [],
    count: 0,
    startIndex: 0,
    total: 0,
  },
  groups: [],
  roles: [],
  selectedUser: null,
  selectedGroup: null,
  selectedRole: null,
  roleAssignees: null,
  isLoadingRoleAssignees: false,
  isLoadingMoreRoleAssignees: false,
  hasRoleAssigneesError: false,
  hasMoreRoleAssigneesError: false,
  inviteOptions: {
    roles: [],
    groups: [],
  },
  iconLocations: [],
};

export const handlers = {
  ...userReducers,
  ...groupsReducers,
  ...rolesReducers,
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.ACL_IS_EDITING]: (state: any, action: any) => ({
    ...state,
    isEditing: action.payload,
  }),
};

export default createReducer(initialState, handlers);
